import { deepClone, safeJSONParser } from "@/utils/format";

const BASE_URL = 'https://data.mefood.io';
const headers = {
    'Content-Type': 'application/json',
    'Authorization': import.meta.env.VITE_API_ORBBYTE_KEY
};
export let CalooAdminConfig: any = {};

export async function getCalooAdminInfo(
    idPost = "4a6c4b9c1d0b76f29c9afce5b16c2548c635ba57e33bc00bd21be26dbac6097e",
    language = "default"
) {
    try {
        const response = await fetch(
            `${BASE_URL}/getAdminById/${idPost}/${language}`,
            {
                method: "GET",
                headers,
            }
        );

        if (!response.ok) {
            console.error(`❌ Error HTTP ${response.status}: ${response.statusText}`);
            return {
                statusCode: response.status,
                message: response.statusText,
            };
        }

        const raw = await response.json();
        // console.log("📥 Admin info response:", raw);

        // Verifica estructura esperada
        if (!raw || !raw.data || !Array.isArray(raw.data) || !raw.data[0]) {
            console.warn("⚠️ Respuesta inesperada, no contiene datos válidos.");
            return {
                statusCode: 404,
                message: "No se encontraron datos en la respuesta.",
            };
        }

        CalooAdminConfig = {
            googleApi: raw.data[0].googleApi,
            orbbyteApi: raw.data[0].orbbyteApi,
            storesProducts: raw.data[0].storesProducts,
            popupId: raw.data[0].popupId,
            aIModel: raw.data[0].aIModel,
            premiums: raw.data[0].premiums,
            nijiConfig: safeJSONParser(raw.data[0].nijiConfiguration) || {},
            defaultPrompt: raw.data[0].nijiPremiumConfiguration || null,
            defaultImagePrompt: raw.data[0].promptImageCapture || null,
            defaultAudioPrompt: raw.data[0].promptAudioCapture || null,
            defaultEditPrompt: raw.data[0].promptEditRecipe || null,
            enablePromoCode: (raw.data[0].promoCodes === "true" ? true : false) || false,
            imageSize: raw.data[0].imageSize || 768,
            imageQuality: raw.data[0].imageQuality || 85,
            enableConnectionDetection: (raw.data[0].enableConnectionDetection === "true" ? true : false) || false,
        };
        console.log("✅ Configuración cargada correctamente:", CalooAdminConfig);

        return CalooAdminConfig;
    } catch (error: any) {
        console.error("❌ Error getCalooAdminInfo:", error);
        return {
            statusCode: 500,
            message: error?.message || "Error desconocido.",
        };
    }
}
